export const server_auths = {
  api_key: {
    text:'API Key',
    value:'api_key'
  },
  basic_auth: {
    text:'Basic auth',
    value:'basic_auth'
  }
}